import { useQuery } from "react-query";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

const getAllBanksByCountryCode = async (code) => {
  if (code) {
    const { data } = await getDataWithDotNet(
      `${ajaxEndpoints.GET_BANK_LIST_BY_COUNTRY_CODE}?country_code=${code}`
    );
    return data;
  }
};

export default function useAllBanksByCountryCode(code) {
  return useQuery(
    [code, "getAllBanksByCountryCode"],
    getAllBanksByCountryCode,
    {
      refetchOnWindowFocus: false,
    }
  );
}
